/* iceberg-ui */
import { Box } from '@auviknetworks/iceberg-ui';

/*  React  */
import React from 'react';

/*  Components  */
import { UsageBreakdown } from './UsageBreakdown';
import UsageDailyBreakdown from './UsageDailyBreakdown';
import { UsageOverview } from './UsageOverview';
import { UsageVsAdoption } from './UsageVsAdoption';

export const UsageReports = (props) => {
    const { renderingScheduledReport, reportData, reportSetup } = props;
    const {
        organizationalUsageOverview,
        organizationalUsageOverviewBreakdown,
        organizationalUsageVsAdoption,
        organizationalUsageDailyBreakdown
    } = reportData || {};

    return (
        <Box data-trackid="usageReportGridContainer" width="100%">
            {/* organizational */}
            {organizationalUsageOverview && (
                <Box
                    data-trackid="usageReportOrganizationalUsageOverviewWrapper"
                    id="organizationalUsageOverview"
                >
                    <UsageOverview
                        renderingScheduledReport={renderingScheduledReport}
                        reportData={organizationalUsageOverview}
                    />
                </Box>
            )}
            {organizationalUsageOverviewBreakdown && (
                <Box
                    data-trackid="usageReportOrganizationalUsageOverviewBreakdownWrapper"
                    id="organizationalUsageOverviewBreakdown"
                >
                    <UsageBreakdown
                        renderingScheduledReport={renderingScheduledReport}
                        reportSetup={reportSetup}
                        reportData={organizationalUsageOverviewBreakdown}
                    />
                </Box>
            )}
            {organizationalUsageVsAdoption && (
                <Box
                    data-trackid="usageReportOrganizationalUsageVsAdoptionWrapper"
                    id="organizationalUsageVsAdoption"
                >
                    <UsageVsAdoption
                        reportData={organizationalUsageVsAdoption}
                    />
                </Box>
            )}
            {organizationalUsageDailyBreakdown && (
                <Box
                    width="100%"
                    data-trackid="usageReportOrganizationalUsageDailyBreakdownWrapper"
                    className="break-before"
                    id="organizationalUsageDailyBreakdown"
                >
                    <UsageDailyBreakdown
                        renderingScheduledReport={renderingScheduledReport}
                        reportSetup={reportSetup}
                        reportData={organizationalUsageDailyBreakdown}
                    />
                </Box>
            )}
        </Box>
    );
};
